<div>
  <select class="form-select" [formControl]="storeInputCtrl" aria-label="Select Store">
    <option value="" disabled>Select store</option>
    <option [value]="store.id" *ngFor="let store of stores">{{store.name}}</option>
  </select>
</div>
